<template lang="pug">
.succesSstep
    YboxIframe(:amount="`${planSelect.totalValue}`" :uuid="`${planSelect.uuid}`")
    .succesSstep__container
      .succesSstep__header
        img.succesSstep__header__image(alt="Sucesso" src="@/assets/icons/ok.svg")
        h1.succesSstep__header__title(v-html="headerText")

      .succesSstep__body

        NPS(:name="voucherRecipient.name" :email="voucherRecipient.email" typePayment="creditCard")

        .cardCheckout.cardInsuranceDetails(v-if="planSelect")
          h3.cardInsuranceDetails__title Detalhes do seguro

          ol.cardInsuranceDetails__list
            li.cardInsuranceDetails__list__item.cardInsuranceDetails__list__item--destiny(v-if="destination")
              span.cardInsuranceDetails__list__item__label Destino
              b.cardInsuranceDetails__list__item__value {{ destination.destination }}

            li.cardInsuranceDetails__list__item.cardInsuranceDetails__list__item--passengers
              span.cardInsuranceDetails__list__item__label Passageiros
              div.cardInsuranceDetails__list__item--passengers__container
                span.cardInsuranceDetails__list__item__value(v-if="!!inputedAgePassengers" v-html="inputedAgePassengers")

            li.cardInsuranceDetails__list__item.cardInsuranceDetails__list__item--travelDate
              div(:class="{'noMarginLeft': !destination}")
                span.cardInsuranceDetails__list__item__label Vigência
                b.cardInsuranceDetails__list__item__value {{ initialDate | date8601 }} ~ {{ endDate | date8601 }}

            li.cardInsuranceDetails__list__item.cardInsuranceDetails__list__item--coverage
              span.cardInsuranceDetails__list__item__label Cobertura
              span.cardInsuranceDetails__list__item__value #[b {{ planSelect.packageLabel }}] /pessoa

            li.cardInsuranceDetails__list__item.cardInsuranceDetails__list__item--wallter
              span.cardInsuranceDetails__list__item__label Pagamento
              span.cardInsuranceDetails__list__item__value(v-html="paymentend")

            li(v-if="partnerName" :class="'cardInsuranceDetails__list__item cardInsuranceDetails__list__item--' + partnerName")
              span.cardInsuranceDetails__list__item__label Você ganhou
              span.cardInsuranceDetails__list__item__value #[b {{ scorePoints }}] pontos {{partnerName}}

            li.cardInsuranceDetails__list__item.cardInsuranceDetails__list__item--chip(v-if="planSelect.includeChip")
              span.cardInsuranceDetails__list__item__label Chip internacional
              b.cardInsuranceDetails__list__item__value 1 Chip digital eSIM

        div.ciclicCellphoneCTA
          CellphoneCTA

    div.ciclicCellphoneModal
      CellphoneModal
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { date8601, currency } from '@/filters'
import cpFeedback from '@/components/Feedback.vue'
import YboxIframe from '../YboxIframe/index.vue'
import NPS from '@/components/NPS.vue'
import CellphoneCTA from '@/components/CellphoneCTA.vue'
import CellphoneModal from '@/components/CellphoneModal.vue'

export default {
  name: 'CreditCard',
  components: {
    cpFeedback,
    YboxIframe,
    NPS,
    CellphoneCTA,
    CellphoneModal
  },
  data () {
    return {
      scorePoints: 0
    }
  },
  filters: {
    currency,
    date8601
  },
  computed: {
    ...mapState('travelSetup', ['theme']),
    ...mapGetters('quotation', ['destination', 'partnerName', 'selectedCovidCovers']),
    ...mapState('payment', ['installment']),
    ...mapState('quotation', [
      'initialDate',
      'endDate',
      'result',
      'numberOfPassengersFourtyYears',
      'numberOfPassengersSixtyFourYears',
      'numberOfPassengersSeventyFiveYears',
      'numberOfPassengersEightyFiveYears',
      'numberOfPassengersNinetyNineYears',
      'selectedQuote',
      'destinationId'
    ]),
    ...mapState('user', ['voucherRecipient']),
    ...mapState('additional', ['pcr']),
    planSelect () {
      return this.result[this.selectedQuote]
    },
    headerText () {
      return this.planSelect.includeChip
        ? 'Compra realizada com&nbsp;sucesso.<br />Em breve você receberá dois e-mails diferentes: um para fazer download do bilhete e outro com o passo a passo para ativação do seu chip eSIM. Confira sua caixa de entrada ;)'
        : `Compra realizada com&nbsp;sucesso.<br />O bilhete será&nbsp;enviada&nbsp;para o&nbsp;email:<br /><strong>${this.voucherRecipient.email}</strong>`
    },
    paymentend () {
      const totalValue = this.pcr.active ? this.pcr.totalValue : this.planSelect.totalValue
      const label = this.installment <= 1 ? 'À vista: ' : ''
      const valuePlots = totalValue / this.installment
      const value = this.installment <= 1
        ? `<b>${this.$options.filters.currency(totalValue)}</b>`
        : `<b>${this.installment}x de ${this.$options.filters.currency(valuePlots)}</b> s/juros`

      return `${label}${value}`
    },
    inputedAgePassengers () {
      const passengers = [
        {
          checked: this.numberOfPassengersFourtyYears,
          returnString: `<b>${this.numberOfPassengersFourtyYears}</b> até 40 anos`
        }, {
          checked: this.numberOfPassengersSixtyFourYears,
          returnString: `<b>${this.numberOfPassengersSixtyFourYears}</b> de 41 a 64 anos`
        }, {
          checked: this.numberOfPassengersSeventyFiveYears,
          returnString: `<b>${this.numberOfPassengersSeventyFiveYears}</b> de 65 a 75 anos`
        }, {
          checked: this.numberOfPassengersEightyFiveYears,
          returnString: `<b>${this.numberOfPassengersEightyFiveYears}</b> de 76 a 85 anos`
        }, {
          checked: this.numberOfPassengersNinetyNineYears,
          returnString: `<b>${this.numberOfPassengersNinetyNineYears}</b> de 86 a 99 anos`
        }
      ]

      return passengers.filter(obj => obj.checked).map(({ returnString }) => returnString).join(' - ')
    },
    hasCobanPartner () {
      const cobanData = window.sessionStorage.getItem('ciclic:coban')

      return this.theme === 'viagem' ? !cobanData : false
    },
    showChipBanner () {
      return (this.destinationId !== 'BR')
    }
  },
  mounted () {
    if (this.partnerName === 'livelo') {
      this.scorePoints = this.planSelect.liveloPoints
    }
    if (this.partnerName === 'dotz') {
      this.scorePoints = this.planSelect.dotzPoints
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/style/ui/variables";

  .succesSstep {
    background-color: #f1f4f9;
    padding: 24px 0 1px 0;

    &__container {
      max-width: 600px;
      margin: 0 auto 50px;
      text-align: center;

      @media screen and (min-width: 601px) {
        padding: 0 16px;
      }
    }

    &__header {
      &__image {
        height: 48px;
        width: 48px;

        @media screen and (min-width: 426px) {
          height: 68px;
          width: 68px;
        }
      }

      &__title {
        font-size: 18px;
        margin: 16px 0;
        max-width: 600px;
        padding: 0 16px;
        font-weight: normal;

        @media screen and (min-width: 426px) {
          font-size: 24px;
          margin: 16px 24px;
        }

        @media screen and (min-width: 769px) {
          max-width: 600px;
        }
      }
    }

    &__body{
      padding: 0 16px;
    }
  }
  .cardCheckout {
    color: $base-color;
    background-color: $white;

    @media screen and (min-width: 601px) {
      border-radius: 12px;
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    }
  }

  .surveys {
    margin: 24px 0 24px;
    position: relative;

    @media only screen and (min-width: 768px) {
      margin: 40px 0 40px;
    }
  }

  .ciclicCellphoneCTA {
    margin: 16px auto;
  }

  .cardInsuranceDetails {
    padding: 32px 26px 32px 17px;

    @media screen and (min-width: 601px) {
      padding: 40px 70px 40px 148px;
    }

    &__title {
      font-size: 20px;
      text-align: left;
    }

    &__list {
      font-family: $rubik-font-family;
      text-align: left;
      padding-top: 30px;

      &__item {
        padding-bottom: 20px;
        padding-left: 48px;
        position: relative;

        &:before {
          background-position: top center;
          background-repeat: no-repeat;
          content: '';
          height: 26px;
          left: 0;
          position: absolute;
          top: 10px;
          width: 26px;
        }

        &__label {
          display: block;
          font-size: 12px;
          letter-spacing: 0.2px;
        }

        &__value {
          font-size: 14px;
        }

        b {
          font-size: 16px;
          font-weight: 500;
        }

        &--destiny:before {
          background-image: url('~@/assets/icons/destiny.svg');
        }

        &--passengers {
          max-width: 420px;

          &:before {
            background-image: url('~@/assets/icons/avatar.svg');
          }

          &__container {
            display: flex;
            flex-wrap: wrap;

            span {
              width: 130px;
            }

            b {
              margin-right: 4px;
            }
          }
        }

        &--travelDate {
          display: flex;

          &:before {
            background-image: url('~@/assets/icons/calendar.svg');
          }
        }

        &--coverage {
          &:before {
            background-image: url('~@/assets/icons/roof.svg');
          }

          span:nth-child(2) {
            font-size: 16px;
          }
        }

        &--coverageCovid:before {
            background-image: url('~@/assets/icons/covid-protection-shield.svg');
            background-size: cover;
            height: 31px;
        }

        &--wallter:before {
          background-image: url('~@/assets/icons/wallter.svg');
        }

        &--livelo:before {
          background-image: url('~@/assets/icons/liveloPoints.svg');
        }

        &--dotz:before {
          background-image: url('https://ciclic.imgix.net/logos/logo_dotz.png?auto=format,compress');
          background-size: 100%;
          background-position: center center;
        }

        &--chip:before {
          background-image: url('~@/assets/icons/sim-card.svg');
        }
      }
    }
  }
</style>
